// src/sectors/pilates/sessions/api/sessionsApi.js
import { http } from 'shared/api/http';

const BASE = '/api/v1/pilates/sessions';

function buildQS(params = {}) {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v === undefined || v === null || v === '') return;
    qs.set(k, String(v));
  });
  return qs.toString();
}

export const sessionsApi = {
  // =========================
  // CREATE (GENERAL)
  // =========================
  createSession: (payload) => http(BASE, { method: 'POST', body: payload, auth: true }),

  validateCreateSession: (payload) => {
    console.log('[API] validateCreateSession payload =>', payload);
    return http(`${BASE}/validate`, { method: 'POST', body: payload, auth: true });
  },

  listWeekly: ({ day, trainerId, status } = {}) => {
    const qs = new URLSearchParams();
    if (day) qs.set('day', day);
    if (trainerId != null) qs.set('trainerId', String(trainerId));
    if (status) qs.set('status', status);
    return http(`${BASE}/weekly?${qs.toString()}`, { method: 'GET', auth: true });
  },

  listMonthly: ({ day, trainerId, status } = {}) => {
    const qs = new URLSearchParams();
    if (day) qs.set('day', day);
    if (trainerId != null) qs.set('trainerId', String(trainerId));
    if (status) qs.set('status', status);
    return http(`${BASE}/monthly?${qs.toString()}`, { method: 'GET', auth: true });
  },

  deleteSession: (id) => http(`${BASE}/${id}`, { method: 'DELETE', auth: true }),

  updateSession: (sessionId, payload) =>
    http(`${BASE}/${sessionId}`, { method: 'PUT', body: payload, auth: true }),

  getSession: (id) => http(`${BASE}/${id}`, { method: 'GET', auth: true }),

  // =========================
  // MOVE
  // =========================
  moveValidate: (payload) =>
    http(`${BASE}/move/validate`, { method: 'POST', body: payload, auth: true }),
  moveCommit: (payload) =>
    http(`${BASE}/move/commit`, { method: 'POST', body: payload, auth: true }),

  // =========================
  // COPY
  // =========================
  copyCommit: (payload) =>
    http(`${BASE}/copy/commit`, { method: 'POST', body: payload, auth: true }),
  copyValidate: (payload) =>
    http(`${BASE}/copy/validate`, { method: 'POST', body: payload, auth: true }),

  // =========================
  // WEEK COPY
  // =========================
  weekCopyPreview: (payload) =>
    http(`${BASE}/week-copy/preview`, { method: 'POST', body: payload, auth: true }),
  weekCopyCommit: (payload) =>
    http(`${BASE}/week-copy/commit`, { method: 'POST', body: payload, auth: true }),

  // =========================
  // PAID / FREE
  // =========================
  getSessionDetail: (id) => http(`${BASE}/${id}`, { method: 'GET', auth: true }),

  createPaidSession: (payload) =>
    http(`${BASE}/paid`, { method: 'POST', body: payload, auth: true }),
  validatePaidSession: (payload) =>
    http(`${BASE}/paid/validate`, { method: 'POST', body: payload, auth: true }),

  createFreeSession: (payload) =>
    http(`${BASE}/free`, { method: 'POST', body: payload, auth: true }),
  validateFreeSession: (payload) =>
    http(`${BASE}/free/validate`, { method: 'POST', body: payload, auth: true }),

  // =========================
  // ✅ SESSION PAYMENTS (NEW)
  // =========================
  /**
   * GET /api/v1/pilates/sessions/payments/pending?from&to&trainerId&q&limit
   * Dönen: PendingSessionPaymentItemResponse[]
   */
  pendingSessionPayments: (params = {}) => {
    const qs = buildQS({
      from: params.from,
      to: params.to,
      trainerId: params.trainerId,
      q: params.q,
      limit: params.limit ?? 200,
    });
    return http(`${BASE}/payments/pending?${qs}`, { method: 'GET', auth: true });
  },

  /**
   * POST /api/v1/pilates/sessions/payments/receive
   * body: { sessionParticipantId, amountTry, method, note }
   */
  receiveSessionPayment: (payload) => {
    console.log('[API] receiveSessionPayment payload =>', payload);
    return http(`${BASE}/payments/receive`, { method: 'POST', body: payload, auth: true });
  },

  // =========================
  // SESSION NOTES
  // =========================
  listSessionNotes: (sessionId) =>
    http(`${BASE}/${sessionId}/notes`, { method: 'GET', auth: true }),
  createSessionNote: (sessionId, payload) =>
    http(`${BASE}/${sessionId}/notes`, { method: 'POST', body: payload, auth: true }),
  deleteSessionNote: (sessionId, noteId) =>
    http(`${BASE}/${sessionId}/notes/${noteId}`, { method: 'DELETE', auth: true }),

  // =========================
  // MEMBER TIMELINE
  // =========================
  getMemberTimeline: (memberId, { from, to, limit = 100 } = {}) => {
    const qs = new URLSearchParams();
    if (from) qs.set('from', from);
    if (to) qs.set('to', to);
    if (limit != null) qs.set('limit', String(limit));
    return http(`${BASE}/member/${memberId}/timeline?${qs.toString()}`, {
      method: 'GET',
      auth: true,
    });
  },

  // =========================
  // MEMBER WEEKLY SESSIONS
  // =========================
  listWeeklyForMember: ({ memberId, day, status } = {}) => {
    const qs = new URLSearchParams();
    if (memberId != null) qs.set('memberId', String(memberId));
    if (day) qs.set('day', day);
    if (status) qs.set('status', status);

    return http(`${BASE}/weekly/member?${qs.toString()}`, {
      method: 'GET',
      auth: true,
    });
  },
};
